import { useNavigate } from 'react-router-dom';

export default function CartHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center px-3 py-[10px] h-[50px]">
      <div className="w-[30px] h-[30px] flex items-center justify-center">
        <button onClick={() => navigate(-1)} className="flex items-center justify-center">
          <img src="/icons/close.svg" alt="뒤로가기" width={30} height={30} />
        </button>
      </div>
      <h1 className="text-lg font-semibold text-[#1F1F1F]">카트</h1>
      <div className="w-[30px] h-[30px]"></div>
    </div>
  );
}
